module.exports = __webpack_public_path__ + "LatoLatin-Thin.c61da09cfb4dcae1765a.ttf";


//////////////////
// WEBPACK FOOTER
// /Users/davidkross/Project/TaiwaneseTutor/front-end/TaiwaneseTutor/src/assets/fonts/LatoLatin/fonts/LatoLatin-Thin.ttf
// module id = ../../../../../src/assets/fonts/LatoLatin/fonts/LatoLatin-Thin.ttf
// module chunks = styles